<template>
  <div class="toothbrush-info">
    <div class="row">
      <div class="col-md-5 toothbrush-info-img">
        <img :src="info.imgUrl">
      </div>
      <div class="col-md-7 toothbrush-info-text">
        <h3 v-html="info.title" class="mt-5 mt-md-0"></h3>
        <p v-html="info.text"></p>
        <p v-if="redirect">
          <strong>Každý deň</strong> sa však môžeš zobudiť s inou náladou. <strong><span v-on:click="scroll">Preto si pozri</span></strong>, aké pasty
          ti môžu robiť spoločnosť <strong><span v-on:click="scroll">ďalšie dni!</span></strong>
        </p>
        <p v-if="!redirect">
          <strong>Každý deň</strong> sa však môžeš zobudiť s inou náladou. <strong><router-link :to="{name: 'PasteList'}">Preto si pozri</router-link></strong>, aké pasty
          ti môžu robiť spoločnosť <strong><router-link :to="{name: 'PasteList'}">ďalšie dni!</router-link></strong>
        </p>
        <div class="buy text-center text-lg-left">
          <a class="be-you-btn be-you-btn-narrow" :href="info.pasteUrl" :style="info.btnStyle" target="_blank">Kúpiť pastu</a>
          <div class="divider"></div>
          <a :href="info.playlist" class="playlist" target="_blank"><strong>Tu</strong> si stiahneš playlist šitý na tvoju dnešnú náladu</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Quiz from '../quiz'
import VueScrollTo from 'vue-scrollto'

export default {
  props: [
    'toothbrush',
    'redirect'
  ],
  computed: {
    info () {
      let imgUrl = ''
      let title = 'Tvoja dnešná nálada je '
      let text = ''
      let pasteUrl = ''
      let playlist = ''

      if (this.toothbrush.name) {
        imgUrl = '/static/img/' + this.toothbrush.name.split(' ').join('_') + '.png'
        title += '<strong>' + this.toothbrush.name + '!</strong>'
      }
      if (this.toothbrush.pasteUrl) {
        pasteUrl = this.toothbrush.pasteUrl
      }
      if (this.toothbrush.gender && this.toothbrush.key && this.toothbrush.environment) {
        text =
          Quiz.results.colors[this.toothbrush.gender][this.toothbrush.key] + ' ' +
          Quiz.results.environment[this.toothbrush.gender][this.toothbrush.environment] + '<br>' +
          Quiz.results.paste[this.toothbrush.key]
      } else if (this.toothbrush.gender && this.toothbrush.key) {
        text =
          Quiz.results.colors[this.toothbrush.gender][this.toothbrush.key] + '.<br>' +
          Quiz.results.paste[this.toothbrush.key]
      }

      if (this.toothbrush.playlist) {
        playlist = this.toothbrush.playlist
      }

      return {
        imgUrl: imgUrl,
        title: title,
        text: text,
        pasteUrl: pasteUrl,
        playlist: playlist
      }
    }
  },
  components: {
  },
  methods: {
    scroll: function () {
      VueScrollTo.scrollTo('.toothbrushes')
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/css/variables.scss";

  .toothbrush-info {
    padding: 90px 0;
    p > strong {
      > a {
        color: $color-blue-text;
      }
      > span {
        cursor: pointer;
      }
    }
    h3 {
      font-size: 30px;
    }
    &-img {
      text-align: right;
      img {
        max-width: 100%;
      }
    }
    &-text {
      text-align: left;
      color: $color-blue-text;
      h3 {
        padding-bottom: 30px;
      }
      .buy {
        .divider {
          display: none;
        }
        .playlist {
          color: $color-green;
          margin: 10px 20px;
        }
        > * {
          vertical-align: middle;
        }
      }
      p {
        font-size: 18px;
        padding-bottom: 20px;
      }
    }

    @media (max-width: $breakpoint-xl) {
      &-text {
        .buy {
          .playlist {
            max-width: calc(100% - 200px);
          }
          a {
            display: inline-block;
          }
        }
      }
    }
    @media (max-width: $breakpoint-lg) {
      &-text {
        .buy {
          .playlist {
            max-width: none;
            margin-top: 30px;
          }
        }
      }
    }
    @media (max-width: $breakpoint-md - 1px) {
      padding: 30px 0 20px 0;
    }
    @media (max-width: $breakpoint-sm) {
      &-text {
        h3 {
          font-size: 24px;
        }
        .buy {
          .divider {
            display: block;
          }
          .playlist {
            max-width: 155px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/index/ToothbrushInfo.vue